import { confirmClientPrint, sendDirectPrint } from '../labelPrint';
import { getBluetoothBinding, sendBluetoothPayload } from './bluetoothTransport';
import { ensurePhomymoConnection, isPhomymoProfile, sendPhomymoLabel } from './phomymoAdapter';

const sleep = ms => new Promise(resolve => window.setTimeout(resolve, ms));

async function confirmSentWithRetry(backendUrl, jobId) {
  let lastError;
  for (const delay of [0, 300, 900]) {
    if (delay) await sleep(delay);
    try { return await confirmClientPrint(backendUrl, jobId, 'sent'); }
    catch (error) { lastError = error; }
  }
  throw lastError || new Error('Conferma stampa non riuscita');
}

export async function connectDirectPrinter(printer, onProgress = null) {
  if (printer?.connection_type === 'bluetooth' && isPhomymoProfile(printer.protocol_profile)) {
    return ensurePhomymoConnection(getBluetoothBinding(printer.printer_id), onProgress);
  }
}

export async function printLabel(backendUrl, job, printer) {
  await connectDirectPrinter(printer);
  const prepared = await sendDirectPrint(backendUrl, job);
  if (prepared.delivery_mode !== 'bluetooth') return prepared;

  try {
    if (prepared.renderer === 'phomemo_m_series') {
      await sendPhomymoLabel({
        binding: getBluetoothBinding(printer.printer_id),
        renderSource: prepared.render_source,
        copies: prepared.copies,
      });
    } else {
      await sendBluetoothPayload(printer, prepared.payload_base64, prepared.transport_config);
    }
  } catch (error) {
    const partial = Number(error?.bytesWritten || 0) > 0 || !!error?.writeAttempted;
    const status = partial ? 'uncertain' : 'failed';
    try { await confirmClientPrint(backendUrl, prepared.print_job_id, status, error?.message || 'Errore Bluetooth'); }
    catch { /* preserve the physical-send error */ }
    if (partial) throw new Error('Connessione Bluetooth interrotta durante l’invio. Esito incerto: verifica l’etichetta prima di ristampare.');
    throw new Error(error?.message || 'Invio Bluetooth non riuscito');
  }

  // At this point all bytes were delivered to the printer characteristic.  A
  // failure while archiving must never be converted into a physical-print retry.
  try {
    const confirmed = await confirmSentWithRetry(backendUrl, prepared.print_job_id);
    return { ...prepared, ...confirmed, delivery_mode: 'bluetooth' };
  } catch {
    throw new Error('Dati inviati alla stampante, ma Klaro non ha confermato la registrazione. Non ristampare automaticamente: verifica l’etichetta e riprova la connessione.');
  }
}
